export default {"src":"/_next/static/media/nextArrow2.d5950f62.svg","height":56,"width":56};